import React from "react";
import { Link } from "react-router-dom";
import {
  RiYoutubeLine,
  RiInstagramLine,
  RiFacebookLine,
  RiTwitterXLine,
  RiPinterestLine,
  RiGithubLine,
} from "react-icons/ri";

const Socials = () => {
  return (
    <div className="flex items-center gap-x-5 text-lg">
      <Link
        to={"https://github.com/Invisible-Bot-Java"}
        target="_blank"
        className="hover:text-accent transition-all duration-300"
      >
        <RiGithubLine />
      </Link>
      <Link
        to={"https://www.youtube.com/@DevForgePro"}
        target="_blank"
        className="hover:text-accent transition-all duration-300"
      >
        <RiYoutubeLine />
      </Link>
      <Link
        to={"httP://www.facebook.com"}
        target="_blank"
        className="hover:text-accent transition-all duration-300"
      >
        <RiFacebookLine />
      </Link>
      <Link
        to={"https://www.instagram.com/dev_forge_pro"}
        target="_blank"
        className="hover:text-accent transition-all duration-300"
      >
        <RiInstagramLine />
      </Link>
      <Link to={"/"} className="hover:text-accent transition-all duration-300">
        <RiTwitterXLine />
      </Link>
      <Link to={"/"} className="hover:text-accent transition-all duration-300">
        <RiPinterestLine />
      </Link>
    </div>
  );
};

export default Socials;
